import { toast } from "sonner";

interface ToastHandlerOptions {
  description: any;
  variant?: "default" | "destructive" | "success" | "warning" | "info";
  duration?: number;
  title?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
}

export function toastHandler({
  description,
  variant = "default",
  duration = 3000,
  title = "Aviso",
  action,
}: ToastHandlerOptions) {
  let message: string | string[] =
    "Something went wrong. Please try again later.";

  if (typeof description === "string") {
    message = description;
  } else if (description?.message) {
    message = description.message;
  } else if (description?.response?.data?.message) {
    message = description.response.data.message;
  }

  const messageStr = Array.isArray(message) ? message.join("\n") : message;

  if (variant === "destructive") {
    toast.error(title, {
      description: messageStr,
      duration,
      action: action && {
        label: action.label,
        onClick: action.onClick,
      },
      style: {
        background: "#fee2e2",
        color: "#b91c1c",
        border: "1px solid #fca5a5",
        borderRadius: "0.75rem",
        boxShadow: "0 2px 8px 0 rgba(220,38,38,0.08)",
      },
      icon: "❌",
    });
  } else if (variant === "success") {
    toast.success(title, {
      description: messageStr,
      duration,
      action: action && {
        label: action.label,
        onClick: action.onClick,
      },
      style: {
        background: "#dcfce7",
        color: "#166534",
        border: "1px solid #86efac",
        borderRadius: "0.75rem",
        boxShadow: "0 2px 8px 0 rgba(34,197,94,0.08)",
      },
      icon: "✅",
    });
  } else if (variant === "warning") {
    toast.warning(title, {
      description: messageStr,
      duration,
      action: action && {
        label: action.label,
        onClick: action.onClick,
      },
      style: {
        background: "#fef9c3", // yellow-100
        color: "#92400e", // yellow-800
        border: "1px solid #fde68a", // yellow-300
        borderRadius: "0.75rem",
        boxShadow: "0 2px 8px 0 rgba(251,191,36,0.08)",
      },
      icon: "⚠️",
    });
  } else if (variant === "info") {
    toast.warning(title, {
      description: messageStr,
      duration,
      action: action && {
        label: action.label,
        onClick: action.onClick,
      },
      style: {
        background: "#dbeafe", // blue-100
        color: "#1e40af", // blue-800
        border: "1px solid #93c5fd", // blue-300
        borderRadius: "0.75rem",
        boxShadow: "0 2px 8px 0 rgba(251,191,36,0.08)",
      },
      icon: "ℹ️",
    });
  } else {
    toast(title, {
      description: messageStr,
      duration,
      action: action && {
        label: action.label,
        onClick: action.onClick,
      },
    });
  }
}
